import { Component } from '@angular/core';
import { map, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { AbstractBlDynamicGuide, GuideContent, ModalOption } from '@blcloud/bl-ng-ui-component';
import { IPrintCompanyInfo } from '@blcloud/bl-datamodel';
import { PrintCompanyInfoResource } from '@blcloud/bl-ng-resource';
import { BlConditionInfo, BlConditionType } from '@blcloud/bl-ng-common';
import { LogicalDeleteDiv } from '@blcloud/bl-datamodel/enum/common/logical-delete-div';
import { isNil as _isNil} from 'lodash';

/**
 * 自社名選択ガイドコンポーネント
 */
@Component({
  templateUrl: './company-name-select-guide.component.html',
})
export class CompanyNameSelectGuideComponent extends AbstractBlDynamicGuide {

  title = '自社名選択ガイド';

  /** ガイドコンテンツ */
  guideContents: GuideContent[] = [
    {
      navText: '自社名を選択してください。',
      filterKey: 'companyName1',
      tableContent: {
        headers: [
          { key: 'printCompanyCd', label: '自社コード', width: '20%' },
          { key: 'companyName1', label: '自社名1', width: '40%' },
          { key: 'companyName2', label: '自社名2', width: '40%' },
        ]
      }
    }
  ];

  /** 返却データ */
  returnData: IPrintCompanyInfo = {};

  /**
   * コンストラクタ
   *
   * @param printCompanyInfoResource 印刷自社情報リソースクラス
   */
  constructor(private printCompanyInfoResource: PrintCompanyInfoResource) {
    super();
  }

  onShown() {
    this.showLoading();
    this.setTableObservables(this.fetch())
      .pipe(finalize(() => this.hideLoading()))
      .subscribe(() => {
        // 初期選択
        if (!_isNil(this.data.printCompanyCd)) {
          this.initSelect('printCompanyCd', Number(this.data.printCompanyCd));
        } else {
          this.initSelectFirst();
        }
      });
  }

  /**
   * 印刷自社情報取得
   * @returns 印刷自社情報
   */
  private fetch(): Observable<IPrintCompanyInfo[]> {
    // 検索条件
    const conditions: BlConditionInfo[] = [
      { key: 'logicalDeleteDiv', value: LogicalDeleteDiv.Valid, type: BlConditionType.Equal }
    ];

    // ソートフィールド
    const sortFields = [
      { field: 'printCompanyCd', desc: false }
    ];

    return this.printCompanyInfoResource.getAll<IPrintCompanyInfo>(
      { conditions, sortFields },
      { consistent: false }
    ).pipe(
      map(res => res && res.searchResultList ? res.searchResultList : [])
    );
  }

  /**
   * 結果取得
   *
   * @returns 選択された自社名の情報
   */
  getResults(): IPrintCompanyInfo {
    return this.returnData;
  }

  /**
   * 行選択イベント処理
   *
   * @param focusRowData 選択行
   */
  onSelectRow(focusRowData: any) {
    if (focusRowData.data) {
      this.returnData.printCompanyCd = focusRowData.data.printCompanyCd;
      this.returnData.companyName1 = focusRowData.data.companyName1;
      this.returnData.companyName2 = focusRowData.data.companyName2;
    }
  }

  /**
   * デフォルトオプション指定
   *
   * @returns デフォルトオプション
   */
  defaultOption(): ModalOption {
    return { animated: true };
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/slip-print-detail-setting/tab/slip-print-detail-setting-for-header/company-name-select-guide/company-name-select-guide.component.ts